import styled from 'styled-components';

export const StyledHowToSection = styled.section`
    margin: 0 15px;
    text-align: center;
    color: #515151;

    & strong {
        display: block;
        margin: 30px 0 100px 0;
        padding: 0 30px;
        font-size: 16px;
        line-height: 20.4px;
        font-weight: 500;
    }

    @media screen and (min-width: 577px) {
        max-width: 925px;
        width: 100%;
        margin: 0;

        & strong {
            margin: 20px 0 38px 0;
        }
    }
`;

export const StyledHowToSectionContent = styled.article`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0 0 0;
    padding: 20px 16px;

    border: none;
    border-radius: 20px;
    background-color: #e7e7e7;
    background-image: image-set(
        url('assets/mobile-login-2x.webp') 1x type('image/webp'),
        url('assets/mobile-login-2x.png') 1x type('image/png'),
        url('assets/mobile-login-2x.webp') 2x type('image/webp'),
        url('assets/mobile-login-2x.png') 2x type('image/png'),
        url('assets/mobile-login-3x.webp') 3x type('image/webp'),
        url('assets/mobile-login-4x.png') 3x type('image/png')
    );

    background-position: bottom center;
    background-repeat: no-repeat;
    text-align: left;
    font-size: 16px;
    line-height: 20.4px;

    & a {
        width: 100%;
        max-width: 480px;
        margin: 314px 30px 0 30px;
        font-size: 20px;
        line-height: 25.5px;
    }

    @media screen and (min-width: 577px) {
        align-items: flex-start;
        margin: 70px 0 0 0;
        padding: 32px 42% 32px 30px;
        font-weight: 500;
        font-size: 20px;
        line-height: 25.5px;
        border-radius: 30px;
        background-image: image-set(
            url('assets/desktop-login-2x.webp') 1x type('image/webp'),
            url('assets/desktop-login-2x.png') 1x type('image/png'),
            url('assets/desktop-login-2x.webp') 2x type('image/webp'),
            url('assets/desktop-login-2x.png') 2x type('image/png'),
            url('assets/desktop-login-3x.webp') 3x type('image/webp'),
            url('assets/desktop-login-4x.png') 3x type('image/png')
        );
        background-position: bottom right;
        background-size: 38%;

        & a {
            width: auto;
            margin: 30px 0 0 0;
        }
    }
`;
